/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-0b4c3c44.mjs';
import { defineComponent, computed, provide, createVNode, TransitionGroup } from 'vue';
import props from './props.mjs';
import '../hooks/useConfig.mjs';
import { useTNodeDefault } from '../hooks/tnode.mjs';
import { useCLASSNAMES, injectKey } from './constants.mjs';
import useTree from './useTree.mjs';
import useExposeFunc from './hooks/useExposeFunc.mjs';
import { useConfig } from '../config-provider/useConfig.mjs';
import '../_chunks/dep-40522c7c.mjs';
import '../_chunks/dep-a48de419.mjs';
import '../_chunks/dep-83862ee1.mjs';
import '../_chunks/dep-f6b25712.mjs';
import '../_chunks/dep-3ca5fb38.mjs';
import '../_chunks/dep-7071345f.mjs';
import '../_chunks/dep-59545a4d.mjs';
import '../_chunks/dep-c27b1c14.mjs';
import '../_chunks/dep-7d96367f.mjs';
import '../_chunks/dep-4889eb51.mjs';
import '../_chunks/dep-0b4185fe.mjs';
import '../_chunks/dep-d2403b2f.mjs';
import '../_chunks/dep-7922050a.mjs';
import '../_chunks/dep-caad2e91.mjs';
import '../_chunks/dep-3d4aad09.mjs';
import '../_chunks/dep-469bf54b.mjs';
import '../_chunks/dep-8e451077.mjs';
import '../_chunks/dep-a82b01df.mjs';
import '../_chunks/dep-192e10f1.mjs';
import '../_chunks/dep-977c5cdd.mjs';
import '../_chunks/dep-755716aa.mjs';
import '../_chunks/dep-82798823.mjs';
import '../_chunks/dep-52cbb58a.mjs';
import '../_chunks/dep-db11154e.mjs';
import '../_chunks/dep-baa4f9dc.mjs';
import '../utils/render-tnode.mjs';
import '../_chunks/dep-2684fd15.mjs';
import '../_chunks/dep-dcf624da.mjs';
import '../_chunks/dep-556a2f2c.mjs';
import './tree-item.mjs';
import 'tdesign-icons-vue-next';
import '../checkbox/index.mjs';
import '../checkbox/checkbox.mjs';
import '../checkbox/props.mjs';
import '../hooks/useVModel.mjs';
import '../form/hooks.mjs';
import '../hooks/useRipple.mjs';
import '../hooks/useKeepAnimation.mjs';
import '../_chunks/dep-bfb23a5e.mjs';
import '../_chunks/dep-2a7dc5c7.mjs';
import '../_chunks/dep-9311bf66.mjs';
import '../_chunks/dep-169ea640.mjs';
import '../_chunks/dep-827c4600.mjs';
import '../_chunks/dep-0820e0e2.mjs';
import '../_chunks/dep-8e38f523.mjs';
import '../_chunks/dep-8ef9fb8e.mjs';
import '../_chunks/dep-e769aafd.mjs';
import '../_chunks/dep-400798c5.mjs';
import '../_chunks/dep-361522ee.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../utils/set-style.mjs';
import '../checkbox/constants.mjs';
import '../config-provider/type.mjs';
import '../checkbox/group.mjs';
import '../_chunks/dep-8c39d78a.mjs';
import '../_chunks/dep-2ca0e5ff.mjs';
import '../_chunks/dep-c5bb3a66.mjs';
import '../checkbox/checkbox-group-props.mjs';
import '../hooks/slot.mjs';
import '../utils/withInstall.mjs';
import './style/css.mjs';
import '../checkbox/type.mjs';
import '../loading/index.mjs';
import '../loading/directive.mjs';
import '../loading/plugin.mjs';
import '../loading/loading.mjs';
import '../loading/icon/gradient.mjs';
import '../_common/js/loading/circle-adapter.mjs';
import '../_common/js/utils/set-style.mjs';
import '../_common/js/utils/helper.mjs';
import '../_chunks/dep-e68fd68c.mjs';
import '../utils/dom.mjs';
import '../utils/easing.mjs';
import '../utils/transfer-dom.mjs';
import '../loading/props.mjs';
import '../loading/type.mjs';
import './util.mjs';
import '../_chunks/dep-32e8a48d.mjs';
import '../_chunks/dep-0c515b62.mjs';
import '../_chunks/dep-759eacca.mjs';
import '../_chunks/dep-544fb8fd.mjs';
import '../_chunks/dep-72359af2.mjs';
import '../_chunks/dep-ad0cc3b4.mjs';
import '../hooks/useGlobalIcon.mjs';
import './hooks/useDraggable.mjs';
import '../_chunks/dep-2c582e31.mjs';
import '../_chunks/dep-241fdd8c.mjs';
import '../_chunks/dep-050b3eb2.mjs';
import '../_common/js/tree/tree-store.mjs';
import '../_chunks/dep-84a9ab7d.mjs';
import '../_chunks/dep-7ffddffa.mjs';
import '../_common/js/tree/tree-node.mjs';
import '../_chunks/dep-9262ea29.mjs';
import '../_chunks/dep-88e40e6a.mjs';
import '../_chunks/dep-6d14fb16.mjs';
import '../_common/js/tree/tree-node-model.mjs';
import '../_chunks/dep-f1423dd2.mjs';
import '../_chunks/dep-efb50e88.mjs';
import '../_chunks/dep-10db0930.mjs';
import '../_common/js/log/log.mjs';
import '../hooks/useDefaultValue.mjs';
import './hooks/useOnDrag.mjs';

var _TdTree = defineComponent({
  name: "TTree",
  props: props,
  setup: function setup(props2, _ref) {
    var expose = _ref.expose,
        slots = _ref.slots;

    var _useConfig = useConfig("tree"),
        globalConfig = _useConfig.globalConfig,
        t = _useConfig.t;

    var CLASS_NAMES = useCLASSNAMES();
    var renderTNodeJSX = useTNodeDefault();
    var statusContext = computed(function () {
      var checkProps = props2.checkProps,
          empty = props2.empty,
          icon = props2.icon,
          label = props2.label,
          line = props2.line,
          disableCheck = props2.disableCheck,
          operations = props2.operations;
      return {
        checkProps: checkProps,
        empty: empty,
        icon: icon,
        label: label,
        line: line,
        disableCheck: disableCheck,
        operations: operations,
        scopedSlots: slots
      };
    });
    provide(injectKey, statusContext);

    var _useTree = useTree(props2),
        treeStore = _useTree.treeStore,
        treeNodeViews = _useTree.treeNodeViews;

    useExposeFunc(treeStore, expose);
    var classList = computed(function () {
      var _ref2;

      return [CLASS_NAMES.value.tree, (_ref2 = {}, _defineProperty(_ref2, CLASS_NAMES.value.disabled, props2.disabled), _defineProperty(_ref2, CLASS_NAMES.value.treeHoverAble, props2.hover), _defineProperty(_ref2, CLASS_NAMES.value.treeCheckable, props2.checkable), _defineProperty(_ref2, CLASS_NAMES.value.treeTransition, props2.transition), _defineProperty(_ref2, CLASS_NAMES.value.treeBlockNode, props2.expandOnClickNode), _ref2)];
    });
    return function () {
      return createVNode("div", {
        "class": classList.value
      }, [treeNodeViews.value.length === 0 ? createVNode("div", {
        "class": CLASS_NAMES.value.treeEmpty
      }, [renderTNodeJSX("empty", {
        defaultNode: t(globalConfig.value.empty)
      })]) : createVNode(TransitionGroup, {
        "name": CLASS_NAMES.value.treeNodeToggle,
        "tag": "div",
        "enter-active-class": CLASS_NAMES.value.treeNodeEnter,
        "leave-active-class": CLASS_NAMES.value.treeNodeLeave
      }, {
        "default": function _default() {
          return [treeNodeViews.value];
        }
      })]);
    };
  }
});

export { _TdTree as default };
//# sourceMappingURL=td-tree.mjs.map
